/** NB translations for Les Aiguilles Blanches */
const nb: Record<string, string> = {
  subtitle: "Løypemaskin-simulator",
  startGame: "Start spill",
  resumeGame: "Fortsett",
  newGame: "Nytt spill",
  // UNUSED continue: "Fortsett",
  settings: "Innstillinger",
  controls: "Kontroller",
  changelog: "Nyheter",
  howToPlay: "Slik spiller du",
  fullscreen: "Fullskjerm",
  fullscreenHint: "Trykk F for fullskjerm",
  exitFullscreen: "Avslutt fullskjerm",
  back: "Tilbake",
  backToGame: "Tilbake til spillet",
  // UNUSED loading: "Laster...",
  inputKeyboard: "✓ Tastatur oppdaget",
  inputKeyboardOff: "✗ Ingen tastatur",
  inputTouch: "✓ Berøringsskjerm oppdaget",
  inputTouchOff: "✗ Ingen berøringsskjerm oppdaget",
  inputGamepad: "✓ Gamepad tilkoblet",
  inputGamepadOff: "✗ Ingen gamepad",
  updateAvailable: "Ny versjon tilgjengelig — trykk for å laste på nytt",
  madeIn: "Laget med ❄️ i Savoie",
  feedback: "Gi tilbakemelding",
  on: "✓ PÅ",
  off: "✗ AV",
  zoneClosed: "🚫 SONE STENGT",

  // Settings
  language: "Språk",
  accessibility: "Tilgjengelighet",
  highContrast: "Høy kontrast",
  reducedMotion: "Redusert bevegelse",
  showFps: "Vis FPS",
  showDebug: "Feilsøking",
  skiStyle: "Stil",
  skiTricks: "Triks",
  skiBestCombo: "Beste kombo",
  quitGame: "Avslutt spill",
  display: "Visning",
  displayWindowed: "Vindu",
  displayFullscreen: "Fullskjerm",
  displayBorderless: "Rammeløs",
  colorblindMode: "Fargeblindhet",
  none: "Ingen",
  deuteranopia: "Deutan.",
  protanopia: "Protan.",
  tritanopia: "Tritan.",
  // UNUSED move: "Flytt",
  moveUp: "Opp",
  moveDown: "Ned",
  moveLeft: "Venstre",
  moveRight: "Høyre",
  groom: "Preparere",
  winch: "Vinsj",
  pause: "Pause",
  keyboard: "Tastatur",
  clickToRebind: "Klikk for å endre",
  pressKey: "Trykk en tast...",
  pressGamepadButton: "Trykk en gamepad-knapp...",
  noGamepad: "Ingen kontroller tilkoblet",
  gamepadButtons: "Gamepad",
  saved: "Lagret!",
  resetControls: "Tilbakestill",
  controlsReset: "Kontroller tilbakestilt!",
  movementSensitivity: "Følsomhet",
  keyboardLayout: "Layout",
  customBindings: "Egendefinert",
  // UNUSED gamepadSupported: "Gamepad OK",
  touch: "Berøring",
  // UNUSED touchSupported: "Berøring OK",
  noGamepadConnected: "Ingen gamepad tilkoblet",
  gamepadDiagnostic: "Kontrollertest",
  connectGamepadDiag: "Koble til en kontroller for å teste",
  gamepadDiagButtons: "Knapper",
  gamepadDiagSticks: "Spaker",
  gamepadDiagTriggers: "Triggere",

  // Audio
  audio: "Lyd",
  masterVolume: "Hovedvolum",
  musicVolume: "Musikk",
  sfxVolume: "Lydeffekter",
  engineVolume: "Motor",
  voiceVolume: "Stemme",
  ambienceVolume: "Atmosfære",
  mute: "Demp",

  backgroundAudio: "Bakgrunnslyd",
  // Gameplay
  bonus: "Bonus",
  skiMode: "Utforkjøring",
  ski: "Ski",
  snowboard: "Snowboard",
  random: "Tilfeldig",
  skiIt: "Kjør ski!",
  rideIt: "Kjør brett!",
  skiAgain: "Kjør igjen!",
  rideAgain: "Kjør igjen!",
  skiRunSpeed: "Fart",
  skiRunTime: "Tid",
  skiRunGates: "Porter",

  // How to Play hints
  howToPlayMove: "{keys} eller piler for å kjøre",
  howToPlayMoveTouch: "Bruk den virtuelle D-paden",
  howToPlayMoveGamepad: "Venstre stikke eller D-pad for å kjøre",
  howToPlayMoveHybrid: "{keys}/piler eller berørings-D-pad",
  howToPlayGroom: "{groomKey} for å preparere snøen",
  howToPlayGroomTouch: "Hold prepareringsknappen",
  howToPlayGroomGamepad: "for å preparere snøen",
  howToPlayGroomHybrid: "{groomKey} eller hold prepareringsknappen",
  howToPlayFuel: "Hold øye med drivstoff og utholdenhet!",
  howToPlayWinch: "{winchKey} nær en forankring for vinsj",
  howToPlayWinchTouch: "Hold vinsjknappen nær en forankring",
  howToPlayWinchGamepad: "nær en forankring for vinsj",
  howToPlayWinchHybrid: "{winchKey} eller hold vinsjknappen nær en forankring",

  // Winch
  winchSnapped: "💥 Kabelen røk!",
  winchAttached: "🔗 Vinsj festet! Hold {winchKey} for assistanse.",
  winchActive: "VINSJ",
  // UNUSED winchHint: "Trykk {winchKey} nær en nummerert ankerstolpe for vinsj",
  // UNUSED winchHintTouch: "Hold 🔗 for vinsj",
  // UNUSED accessPath: "Servicevei",
  // UNUSED toPiste: "Til løypa",

  // Taunts - Cliff falls
  tauntCliff1: "9 tonn utfor stupet. Forsikringen blir begeistret.",
  tauntCliff2: "Jean-Pierre sa 'ikke for nær kanten!' Husker du?",
  tauntCliff3: "Løypepatrullen tar seg ned med tau. Igjen.",
  tauntCliff4: "Marie avbestiller raclette-reservasjonen din i kveld.",
  tauntCliff5: "Thierry regner allerede ut reparasjonskostnadene...",

  // Taunts - Fuel empty
  tauntFuel1: "Måleren sto på rødt i 10 minutter. Hva så du på?",
  tauntFuel2: "Émilie skrev 'FYLL TANKEN' med store bokstaver på tavla.",
  tauntFuel3: "Selv diesel har sine grenser. Du også, tydeligvis.",
  tauntFuel4: "Jean-Pierre sukker. Han sender Thierry med en kanne.",
  tauntFuel5: "Solen står opp. Løypa er ikke preparert. Skifolket kommer.",

  // Taunts - Time limit
  tauntTime1: "Første stolheis om 3... 2... 1... For sent.",
  tauntTime2: "Skifolket oppdager løypa di. Humpete. Isete. Storslått.",
  tauntTime3: "Jean-Pierre ser på klokken, så på deg, så klokken.",
  tauntTime4: "FIS lurer på hvorfor slalåmen er lagt i sørpe.",
  tauntTime5: "Du hører skilærerne forklare kundene hvorfor det 'ikke er deres feil'.",

  // UNUSED paused: "Pause",
  resume: "Fortsett",
  quitToMenu: "Til menyen",
  levelComplete: "Løype fullført!",
  levelFailed: "Løype mislykket",
  tryAgain: "Prøv igjen",
  coverage: "Dekning",
  time: "Tid",
  // UNUSED rating: "Vurdering",
  nextLevel: "Neste løype",
  // UNUSED replay: "Spill på nytt",
  // UNUSED pressContinue: "Trykk mellomrom eller berør for å fortsette",
  pauseTitle: "⏸️ Pause",
  restart: "Start på nytt",
  skipRun: "Hopp over løp",
  newRun: "Ny løype",
  quit: "Avslutt",
  menu: "Meny",
  levelSelect: "Velg løype",
  locked: "Stengt",
   completeToUnlock: "Fullfør {name} for å låse opp",
  // UNUSED target: "Mål",
  tutorial: "Skiskole",
  timeUsed: "Tid brukt",
  excellent: "Utmerket!",
  good: "Godt jobbet!",
  passed: "Bestått",
  bonusFuel: "Drivstoff brukt",
  bonusFlawless: "Første forsøk",
  bonusSpeed: "Tid",
  bonusWinch: "Vinsj-bruk",
  bonusExplore: "Veier utforsket",
  bonusPrecision: "Prepareringskvalitet",
  retry: "Prøv igjen",
  gameComplete: "Spill fullført!",
  viewCredits: "Se takk",
  creditsTitle: "Gratulerer!",
  creditsSubtitle: "Du har mestret Les Aiguilles Blanches",
  creditsCreatedBy: "Laget av",
  creditsDevelopedWith: "Utviklet med",
  creditsArtDirection: "Kunstnerisk ledelse",
  creditsRetroInspiration: "En hyllest til retroklassikere som SkiFree",
  creditsInspiredBy: "Inspirert av",
  creditsGroomers: "Løypemaskinistene i Savoie",
  creditsDedication: "Til nattskiftene som preparerer løypene mens vi sover",
  creditsThanks: "Takk for at du spilte!",
  creditsSeeYou: "Vi ses på løypene!",
  creditsLine: "Kom igjen, gutten. Sola går opp. Fjellet er klart.",
  playAgain: "Spill igjen",
  skipCredits: "Trykk en tast for å hoppe over",

  // Tutorial
  tutorialName: "Opplæring - Første steg",
  tutorialTask: "Lær deg grunnleggende preparering",
  prologueLine: "Klokken 4. Fjellet er ditt. På'n.",
  prologueSkip: "Trykk for å fortsette",
  tutorialIntro: "Velkommen til Les Aiguilles Blanches!",
  skipTutorial: "⏭️ Hopper over opplæring… Trykk for å gjøre på nytt.",
  skipTutorialGamepad: "⏭️ Hopper over opplæring… Trykk en knapp for å gjøre på nytt.",
  tutorialWelcome: "🏔️ Jean-Pierre, sjefspreparør. Kjør på løypa — bruk {keys} eller ↑↓←→.",
  tutorialWelcomeTouch: "🏔️ Jean-Pierre, sjefspreparør. Kjør på løypa — bruk D-paden til venstre.",
  tutorialWelcomeGamepad: "🏔️ Jean-Pierre, sjefspreparør. Kjør på løypa — bruk venstre stikke eller D-pad.",
  // UNUSED     tutorialControls: "🎮 Styr løypemaskinen med {keys} eller piltastene ↑↓←→.",
  // UNUSED     tutorialControlsTouch: "🎮 Styr løypemaskinen med D-paden ◀▲▼▶ til venstre.",
  // UNUSED     tutorialControlsGamepad: "🎮 Styr løypemaskinen med venstre stikke eller D-pad.",
  // UNUSED     tutorialMove: "➡️ Kom igjen, prøv! Kjør rundt på løypa — all hvit snø må prepareres.",
  // UNUSED     tutorialGroomIntro: "✅ Fint! Nå lærer vi å preparere.",
  tutorialGroomAction: "❄️ Hold {groomKey} mens du kjører for å preparere snøen. Den jevnes ut med en gang.",
  tutorialGroomActionTouch: "❄️ Hold prepareringsknappen til høyre mens du kjører for å preparere snøen.",
  tutorialGroomActionGamepad: "❄️ Hold {groomKey} mens du kjører for å preparere snøen. Den jevnes ut med en gang.",
  tutorialGroomGoal: "📊 Sånn ja! Preparer minst 60% før åpning. Skifolket kommer!",
  // UNUSED   tutorialCoverage: "📊 Ser du? Snøen blir jevnere! Fortsett å preparere løypa.",
  // UNUSED   tutorialHUD: "📈 Sjekk dashbordet øverst: rød stripe er drivstoff, grønn utholdenhet, hvit dekning. Klokken tikker!",
  // UNUSED   tutorialGoal: "🎯 Du må preparere minst 60% av løypa før åpning. Skifolket kommer!",
  // UNUSED tutorialFuel: "⛽ Obs — å kjøre bruker drivstoff. På oppdrag, stopp ved bensinstasjonen.",
  tutorialComplete: "🏆 Bra jobbet! Du kan det grunnleggende. Klar for ditt første ekte oppdrag på grønn løype?",

  level_marmottesName: "Grønn løype - Les Marmottes",
  level_marmottesTask: "Preparer nybegynnerløypa",
  level_chamoisName: "Blå løype - Le Chamois",
  level_chamoisTask: "Preparer effektivt før åpning",
  level_airZoneName: "Snowpark - Air Zone",
  level_airZoneTask: "Forbered freestyle-moduler",
  level_aigleName: "Rød løype - L'Aigle",
  level_aigleTask: "Preparer bratt terreng, håndter drivstoff",
  level_glacierName: "Rød løype - Le Glacier",
  level_glacierTask: "Lær å bruke vinsj i bratte bakker",
  level_tubeName: "Half-pipe - Le Tube",
  level_tubeTask: "Vedlikehold half-pipen for konkurranse",
  level_verticaleName: "Svart løype - La Verticale",
  level_verticaleTask: "Nattoperasjon med vinsj",
  level_colDangereuxName: "Skredsone - Col Dangereux",
  level_colDangereuxTask: "Forbered høyrisikosonen",
  level_tempeteName: "Storm - Gjenoppretting",
  level_tempeteTask: "Rydd løypene etter stormen",
  level_coupeDesAiguillesName: "Coupe des Aiguilles - FIS-finale",
  level_coupeDesAiguillesTask: "Forbered alle løypene til konkurransen",

  // Hazards
  cliffFall: "⚠️ ADVARSEL! Du falt utfor stupet! Oppdraget mislykket.",
  fuelEmpty: "⛽ TOMT FOR DRIVSTOFF! Ikke en dråpe diesel igjen...",
  // UNUSED avalancheZone: "SKREDSONE",
  riskLevelHigh: "HØY",
  avalancheWarning: "⚠️ FARE! Snødekket er ustabilt! Forlat sonen!",
  avalancheTrigger: "🏔️💨 SKRED UTLØST! Ingen flukt mulig!",
  steepWarning: "⚠️ BRATT BAKKE! Bruk vinsjen ({winchKey}) ellers sklir du!",
  steepWarningNoWinch: "⚠️ BRATT BAKKE! Senk farten og bruk serviceveiene for å komme rundt!",
  tumble: "🔄 VELT! Løypemaskinen veltet i bakken!",

  // Taunts - Tumble
  tauntTumble1: "Vinsjen er ikke til pynt. Den er for bakker som dette.",
  tauntTumble2: "Thierry stirrer på skadene. Sier ingenting. Det er verre.",
  tauntTumble3: "Jean-Pierre viste deg hvordan man forankrer. Sov du?",
  tauntTumble4: "En PistenBully koster 4 millioner kroner. Altså, kostet.",
  tauntTumble5: "Bakken virket overkommelig? Løypemaskinen var uenig.",
  featureDestroyedKicker: 'Du kjørte over et parkelement! Kickeren er ødelagt.',
  featureDestroyedRail: 'Du kjørte over et parkelement! Railen er ødelagt.',
  tauntFeature1: 'Det elementet tok tre timer å bygge. Du flatet det på tre sekunder.',
  tauntFeature2: 'Émilie kommer til å ha noen ord med deg om det parkelementet.',
  tauntFeature3: 'Parkcrewet så deg akkurat ødelegge mesterverket deres.',
  tauntFeature4: 'Elementer er for skiløpere, ikke for løypemaskiner. Kjør rundt!',
  tauntFeature5: 'Ett element mindre til morgendagens konkurranse.',
  bonusPipeMastery: 'Halfpipe-mestring',

  // Taunts - Avalanche
  tauntAvalanche1: "Fjellet tilgir sjelden. Det tilga ikke.",
  tauntAvalanche2: "Météo France sa faregrad 4. Leste du det?",
  tauntAvalanche3: "Løypepatrullen finner maskinen til våren. Kanskje.",
  tauntAvalanche4: "Marie hører radiovarselet. Hun vet allerede at det er deg.",
  tauntAvalanche5: "Løypepatrullen hadde sikret sektoren. Du avsikret den.",

  // Taunts - Ski wipeout (fun, self-deprecating)
  tauntSkiWipeout1: "Klassisk velt. Utstyr overalt, verdighet ingensteds.",
  tauntSkiWipeout2: "Stupet brydde seg ikke om skiteknikken din.",
  tauntSkiWipeout3: "Løypepatrullen ler allerede. De så hele greia.",
  tauntSkiWipeout4: "Det skjer når du kjører din egen løype.",
  tauntSkiWipeout5: "Selv steinbukkene grein av den landingen.",

  // Dialogues
  jeanPierreIntro: "Bra jobbet med opplæringen. Nå er det alvor — grønn løype, med klokke og drivstoff å passe på.",
  level_marmottesMid: "Ser du det lysskjæret på toppene? Første dagslys. Det beste med denne jobben — bare deg, maskinen og fjellet som våkner.",
  level_chamoisIntro: "Hei, jeg er Émilie — JP sender deg til den blå løypa. Vis at du kan mer enn å legge fløyel på grønne.",
  level_airZoneIntro: "Snowparken er MITT område — vi bygger noe sykt for dem! Hver modul må sitte perfekt, riderne regner med oss.",
  level_aigleIntro: "L'Aigle er alvor. Hold øye med drivstoffet. Serviceveiene lar deg kjøre opp igjen — se etter de gule og svarte stolpene.",
  level_glacierIntro: "Hei, jeg er Thierry — sikkerhetsansvarlig. Le Glacier er bratt. Jeg har sjekket hver forankring. Trykk {winchKey} ved en stolpe for å feste vinsjen — og vær så snill, ikke slipp.",
  level_glacierIntroTouch: "Hei, jeg er Thierry — sikkerhetsansvarlig. Le Glacier er bratt. Jeg har sjekket hver forankring. Trykk på vinsjknappen ved en stolpe — og vær så snill, ikke slipp.",
  level_tubeIntro: "I morgen er det contest i Tuben! Rene vegger, skarp kant og ingen kuler.",
  level_verticaleIntro: "Nattoppdrag på La Verticale: bratt bakke, farlige kanter. Vinsj er påbudt — bruk de 3 forankringene og hold linjen.",
  level_colDangereuxIntro: "Høy skredfare på passet — vi kjører Skredsikringsprotokoll aktivt. Hold deg unna belastede områder og respekter grensene.",
  level_tempeteIntro: "Stormen har passert. Ta en vin chaud — dette tar en stund!",
  level_coupeDesAiguillesIntro: "Det er den store kvelden. FIS inspiserer i morgen. Hver løype må være perfekt — vis meg hva du har lært.",
  marieWelcome: "Kom og varm deg Chez Marie. En god tartiflette!",
  marieIntro: "Hei! Jeg er Marie, jeg driver restauranten oppe ved løypa. Stikk innom når du vil — et varmt måltid gjør underverker!",

  // Changelog
  changelog_20260219_date: "19. februar 2026",
  changelog_20260219: "🎬 Prolog for nye spillere\n📖 Forenklet opplæring\n🌦️ Tilfeldig menøvær\n🔗 Delbare daglige løyper\n🎥 Filmisk rulletekst",
  changelog_20260222_date: "22. februar 2026",
  changelog_20260222: "🚩 Rebalansering av slalomporter\n💬 Tilbakemeldingsknapp",
  changelog_20260223_date: "23. februar 2026",
  changelog_20260223: "📲 Installer på enheten din og spill offline",
  changelog_20260220_date: "20. februar 2026",
  changelog_20260220: "🗺️ Løypekart\n🎿 Skianlegg-terminologi",
  changelog_20260217_date: "17. februar 2026",
  changelog_20260217: "🏔️ Syv løypeformer\n🎯 Banevariasjon forbedret\n⚡ Jevnere skikjøring",
  changelog_20260216_date: "16. februar 2026",
  changelog_20260216: "🎲 Dagens løyper",
  changelog_20260215_date: "15. februar 2026",
  changelog_20260215: "⚡ Nattgjengivelse oppgradert\n📱 Berøringsknapper i skimodus\n⌨️ Tastaturlayout-gjenkjenning",
  changelog_20260214_date: "14. februar 2026",
  changelog_20260214: "🎪 Tricks & komboer\n🏂 Eggposisjon & halfpipe-fysikk\n👁️ Bedre pistekontrast\n📱 Auto-preparering ved vinsj (touch)\n♿ Høykontrastmodus",
  changelog_20260213_date: "13. februar 2026",
  changelog_20260213: "🚩 Slalomporter\n🏔️ Skihopp\n⚡ Forbedret ytelse\n🎹 Nocturne-pianomusikk\n🔊 Motorvolum justerbar",
  changelog_20260212_date: "12. februar 2026",
  changelog_20260212: "📋 Løypekart\n🔗 Knekbar vinsjtau\n🕹️ Kontrolldiagnostikk\n🍽️ Maries retter\n❄️ Kuldeeksponering",
  changelog_20260211_date: "11. februar 2026",
changelog_20260211: "⛷️ Skikjøring etter preparering\n🎯 Prepareringskvalitet\n🏔️ Fargekodede bratte soner\n🏗️ Park og triks",
  changelog_20260210_date: "10. februar 2026",
  changelog_20260210: "🎵 Musikk og lydeffekter\n🔈 Voluminnstillinger\n⏱️ Autokalibrerte løypetider\n⏭️ Hopp over opplæring\n🏔️ Snøskredsoner redesignet",
  changelog_20260209_date: "9. februar 2026",
  changelog_20260209: "🏔️ Alpine seier/tap-skjermer\n❄️ Snøopphopning under storm\n🏆 Feilfri bonus\n🔊 Vær- og dyreliv-lyd",
  changelog_20260208_date: "8. februar 2026",
  changelog_20260208: "📊 Nytt dashbord\n🏔️ Le Glacier og Coupe des Aiguilles\n🦅 Alpint dyreliv\n🎨 Karakterportretter\n🎮 Tastatur- og gamepad-navigering",
  changelog_20260207_date: "7. februar 2026",
  changelog_20260207: "🎨 Retrodesign\n🎯 Bonusmål\n🕹️ Ombinding av gamepad-knapper\n🎮 Gamepad-menynavigering",
  changelog_20260206_date: "6. februar 2026",
  changelog_20260206: "🛤️ Kjørbare serviceveier\n🕹️ Virtuell joystick\n🌍 5 komplette språk",
  changelog_20260205_date: "5. februar 2026",
  changelog_20260205: "🏔️ Fjellklipper\n🌙 Nattlykter\n🔗 Vinsjmekanikk\n⌨️ Tastaturnavigering",
  changelog_20260204_date: "4. februar 2026",
  changelog_20260204: "🎮 Gamepad-støtte\n📱 Berøringskontroller\n💪 Utholdenhet\n💾 Lagre fremgang\n♿ Tilgjengelighet",
  changelog_20260203_date: "3. februar 2026",
  changelog_20260203: "🚜 Lansering: 9 løyper, skiskole\n❄️ Preparering, drivstoff, skred\n🏆 Takk og progresjon",
  // Key names
  key_space: "MELLOMROM",
  key_shift: "SHIFT",
  key_ctrl: "CTRL",
  key_alt: "ALT",
  key_enter: "ENTER",
  key_tab: "TAB",
  key_esc: "ESC",
  key_del: "SLETT",
  dailyRuns: "Dagens løyper",
  dailyRuns_dailyShift: "Dagskift",
  dailyRuns_randomRun: "Tilfeldig kjøring",
  dailyRuns_rank: "Rangering",
  dailyRuns_seed: "Frø",
  // UNUSED   dailyRuns_start: "Start kontrakt",
  dailyRuns_locked: "Fullfør alle løyper for å låse opp",
  dailyRuns_lockedShared: "Fullfør alle løyper for å låse opp daglige runder og spille denne delte løypa",
  // UNUSED   dailyRun_levelName: "Kontrakt",
  dailyRun_levelTask: "Preparér løypa til måldekning",
  dailyRuns_briefing: "Oppdrag",
  dailyRuns_target: "Mål",
  dailyRuns_timeLimit: "Tid",
  dailyRuns_weather_clear: "Klarvær",
  dailyRuns_weather_light_snow: "Lett snøfall",
  dailyRuns_weather_storm: "Stormforhold",
  dailyRuns_night: "Nattskift",
  dailyRuns_day: "Dagskift",
  rank_green: "Grønn",
  rank_blue: "Blå",
  rank_red: "Rød",
  rank_black: "Svart",
  rank_park: "Park",
  share: "Del",
  copied: "Lenke kopiert!",
  playSharedSeed: "Delt runde",
  dailyRunBriefingJP: "Løypa må klargjøres før heisene åpner. Sett i gang.",
  dailyRunBriefingThierry: "Vær forsiktig der oppe — bratte partier og ustabil snø. Hold deg skjerpet.",
  dailyRunBriefingMarie: "Det blir en kald natt i kveld. Stikk innom restauranten og varm deg hvis du trenger det.",
  dailyRunBriefingEmilie: "Enda en løype. Prøv å slå tiden min!"
};

export default nb;
